import SpecialPricingForm from './SpecialPricingForm';

export default SpecialPricingForm;



// WEBPACK FOOTER //
// ./src/shared/components/SpecialPricingForm/index.js